import { Flex, usePlatformInfo, usePlatformProps } from '@acsbe/ui';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useApplicationViewState } from '../../../context';
import { useDomainSelection } from '../../../context/DomainSelectionContext';
import { BillingCycle, Plan } from './Plan';
import { allFeaturesArray, PlanFeature } from './plan-features';
import { PlanFeatureList } from './PlanFeatureList';
import { LicenseDetails, PlanType } from './types';

interface PlansProps {
  plans: PlanType[];
  license?: LicenseDetails;
  billingCycle: BillingCycle;
  setBillingCycle: Dispatch<SetStateAction<BillingCycle>>;
}

export const Plans = ({ plans, license, billingCycle }: PlansProps) => {
  const p = usePlatformProps();
  const { isTablet, uptoTablet } = usePlatformInfo();
  const { paymentOverlayMessage } = useDomainSelection();
  const [allFeatures, setAllFeatures] = useState<PlanFeature[]>([]);
  const { showPlanComparisonView } = useApplicationViewState();

  useEffect(() => {
    if (license && license.pricingModel) {
      setAllFeatures(allFeaturesArray(license.pricingModel || ''));
    }
  }, [license, license?.pricingModel]);

  if (plans?.length === 0) return null;

  return (
    <Flex
      gap={16}
      // paddingBlockEnd={7.5}
      self="stretch"
      align="center"
      stretch
      radius="xl"
      scale="ghost"
      variant="solid"
      style={{ opacity: paymentOverlayMessage ? '.1' : '1' }}
    >
      <Flex
        row={!uptoTablet}
        align="flex-start"
        self="stretch"
        gap={showPlanComparisonView ? 0 : 3}
        // paddingInline={7.5}
      >
        {showPlanComparisonView && (
          <PlanFeatureList header={true} features={allFeatures} />
        )}
        {isTablet
          ? plans.reduce<JSX.Element[]>((rows, plan, index) => {
              if (index % 2 === 0) {
                const rowPlans = [plans[index], plans[index + 1]].filter(
                  Boolean,
                );
                rows.push(
                  <Flex
                    row
                    key={`row-${index}`}
                    align="flex-start"
                    self="stretch"
                    gap={3}
                  >
                    {rowPlans.map((p) => (
                      <Plan
                        key={p.id}
                        plan={p}
                        billingCycle={billingCycle}
                        license={license}
                        pageCount={license?.pageCount}
                      />
                    ))}
                  </Flex>,
                );
              }
              return rows;
            }, [])
          : plans.map((plan) => (
              <Plan
                key={plan.id}
                plan={plan}
                billingCycle={billingCycle}
                license={license}
                pageCount={license?.pageCount}
              />
            ))}
      </Flex>
    </Flex>
  );
};
